<template>
  <div>
    <div class="card">
      <div class="card-body">
        <h5 v-if="formType == 'post'" class="card-title text-primary">
          Register New item
        </h5>

        <h5 v-if="formType == 'put'" class="card-title text-primary">
          Update {{ newITem.ItemName }}
        </h5>
        <!-- <p>{{ newITem }}</p> -->
        <form @submit.prevent="Onsubmit">
          <BaseInput
            placeholder="Item Name"
            @blur="$v.newITem.ItemName.$touch()"
            :error="$v.newITem.ItemName.$error"
            v-model="newITem.ItemName"
          />
          <BaseInput
            placeholder="washin price"
            @blur="$v.newITem.price.washingPrice.$touch()"
            :error="$v.newITem.price.washingPrice.$error"
            v-model.number="newITem.price.washingPrice"
            type="number"
          />
          <BaseInput
            placeholder="ironing price"
            @blur="$v.newITem.price.ironingPrice.$touch()"
            :error="$v.newITem.price.ironingPrice.$error"
            v-model.number="newITem.price.ironingPrice"
            type="number"
          />

          <BaseInput
            placeholder="washin Express price"
            @blur="$v.newITem.price.ExpWashing.$touch()"
            :error="$v.newITem.price.ExpWashing.$error"
            v-model.number="newITem.price.ExpWashing"
            type="number"
          />
          <BaseInput
            placeholder="ironing Express price"
            @blur="$v.newITem.price.ExpIroning.$touch()"
            :error="$v.newITem.price.ExpIroning.$error"
            v-model.number="newITem.price.ExpIroning"
            type="number"
          />
          <!-- <BaseInput
            placeholder="Both Express price"
            @blur="$v.newITem.price.ExpBoth.$touch()"
            :error="$v.newITem.price.ExpBoth.$error"
            v-model.number="newITem.price.ExpBoth"
            type="number"
          /> -->
          <BaseButton
            :className="{
              'd-none': $v.newITem.$invalid,
              'w-50': true,
              'float-right': true
            }"
            type="submit"
            >Save</BaseButton
          >
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBuss } from "../main";
import { required } from "vuelidate/lib/validators";
export default {
  validations: {
    newITem: {
      ItemName: { required },
      price: {
        washingPrice: { required },
        ironingPrice: { required },
        ExpWashing: { required },
        ExpIroning: { required }
      }
    }
  },
  props: {
    formType: String
  },
  data() {
    return {
      newITem: "",
      SeviceID: null
    };
  },
  methods: {
    ItemProperties() {
      return {
        ItemName: "",
        price: {
          washingPrice: "",
          ironingPrice: "",
          ExpWashing: "",
          ExpIroning: ""
        }
      };
    },
    Onsubmit() {
      let info = {
        url: "/service",
        MutName: "SETAll_Service",
        data: ""
      };
      if (!this.$v.newITem.$invalid && this.formType === "post") {
        info.data = this.newITem;
        this.$store.dispatch("InserNewInfo", info);
        this.newITem = new this.ItemProperties();
        this.$v.$reset();
      } else if (!this.$v.newITem.$invalid && this.formType === "put") {
        let updateService = {
          ...this.newITem,
          _id: this.SeviceID
        };
        info.data = updateService;
        this.$store.dispatch("UdateInfo", info);
        this.newITem = new this.ItemProperties();
        this.$v.$reset();
      }
    }
  },
  created() {
    this.newITem = new this.ItemProperties();
    if (this.formType === "put") {
      eventBuss.$on("ServiceUpdate12", data => {
        this.newITem.ItemName = data.ItemName;
        this.newITem.price.washingPrice = data.price.washingPrice;
        this.newITem.price.ironingPrice = data.price.ironingPrice;
        this.newITem.price.ExpWashing = data.price.ExpWashing;
        this.newITem.price.ExpIroning = data.price.ExpIroning;
        this.SeviceID = data._id;
      });
    }
  }
};
</script>
